import s from './SliderDot.module.scss';

export const SliderDot = () => {
  return <div className={s.dot} />;
};